import React from 'react';

function CleanContent(props){    
  const { t } = props;

  return (
    <>
      <p>{t("cleanliness.p1")}</p>
      <p>{t("cleanliness.p2")}</p>
      <p>{t("cleanliness.p3")}</p>
    </>
  );
}
  

const Cleanliness = (props) => {   
  const { t, t_val, o_val, changeWord } = props;
	let cleanTitle = t("cleanliness.label");
	
    return (<div className="content-ac cl hide">
    <input
      className="ac-input top"
      id="ac-4afd"
      name="ac-4afd"
      data-id="2400"
      data-slug="CLEANLINESS"
      type="checkbox"
      onChange={ () => changeWord('cl clicked') }
    />
    <label className="ac-label" htmlFor="ac-4afd">{ cleanTitle }</label>
    <article className="ac-text ac-4afd"><div className="single-post-interior" tabIndex="0">
        <table>
          <tbody>
            <tr>
              <td>{t("cleanliness.turbidity")}</td>
              <td>{t_val || props.turbidity || "-"}</td>
            </tr>
            <tr>
              <td>{t("cleanliness.oxygen")}</td>
              <td>{o_val || props.oxygen || "-"}</td>
            </tr>
          </tbody>
        </table>
        <CleanContent
          t = {t}
        />
		       
    </div></article>
  </div>
);
}

export default Cleanliness;